<template>
    <div class="bg_fff pt25 pb25 pl20 pr20">
        <div class="tab-title">
            <ul class="flex fs17">
                <li class="color_main">推荐</li>
                <li class="ml20">妇科</li>
                <li class="ml20">产科</li>
                <li class="ml20">肿瘤</li>
                <li class="ml20">生殖医学</li>
            </ul>
        </div>
        <div v-for="item in videoList">
            <ul class="mt30 flex row jcb">
                <li class="color_333 bold flex row aic fs16">
                    <img src='../../assets/icon/education/jxhk.png' class="icon">
                    <span class="ml10">{{item.subTitle}}</span>
                </li>
                <li class="fs14 color_666">
                    查看全部
                </li>
            </ul>
            <ul class="flex row jca">
                <li v-for="i in item.list" :key="i.id" class="mt10 mr10">
                    <div class="video-content-img" :class="'video-content-img'+i.id">
                        <span v-show="i.isLive=='0'">回放</span>
                    </div>
                    <p class="mt10 color_333 fs14 bold">{{i.content}}</p>
                    <div class="video-msg fs12 ">
                        <p class="video-msg-t">
                            <span class="icon-ava">{{i.host}}</span>
                            <span>{{i.zc}}</span>
                            <span>|</span>
                            <span>{{i.ks}}</span>
                        </p>
                        <p class="video-msg-b">
                            <span class="video-msg-ic">乳腺肿瘤</span>
                            <span>1258观看</span>
                            <span style="font-weight: bold;">·</span>
                            <span>189赞</span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>


    </div>

</template>

<script>
  export default {
    name: "education-search-form",
    props: {
      // value: {
      //   type: Object,
      //   default: () => {
      //     return {}
      //   }
      // },
    },
    data() {
      return {
        videoList:[
          {
            subTitle:'精选好课',
            icon:'../../assets/icon/education/jxhk.png',
            list:[
            {
              date:"明天",
              time:"9:00",
              host:"江小白",
              zc:"主任医师",
              ks:"肿瘤外科",
              content:"长了乳腺肿瘤怎么办？会变癌吗",
              id:1,
              src:"../../../images/video-img1.png",
              isLive:"0",
              playVideo:true
            },
            {
              date:"明天",
              time:"9:00",
              host:"江小白",
              zc:"主任医师",
              ks:"肿瘤外科",
              content:"长了乳腺肿瘤怎么办？会变癌吗",
              id:2,
              src:"../../../images/video-img2.png",
              isLive:"1",
              playVideo:true

            },
            {
              date:"明天",
              time:"9:00",
              host:"江小白",
              zc:"主任医师",
              ks:"肿瘤外科",
              content:"长了乳腺肿瘤怎么办？会变癌吗",
              id:3,
              src:"../../../images/video-img3.png",
              isLive:"1",
              playVideo:true

            },
            {
              date:"明天",
              time:"9:00",
              host:"江小白",
              zc:"主任医师",
              ks:"肿瘤外科",
              content:"长了乳腺肿瘤怎么办？会变癌吗",
              id:4,
              src:"../../../images/video-img4.png",
              isLive:"0",
              playVideo:true

            },
            {
              date:"明天",
              time:"9:00",
              host:"江小白",
              zc:"主任医师",
              ks:"肿瘤外科",
              content:"长了乳腺肿瘤怎么办？会变癌吗",
              id:5,
              src:"../../../images/video-img5.png",
              isLive:"0",
              playVideo:true
            },
          ]
          },
          {
            subTitle:'专家直播',
            icon:'../../assets/icon/education/zjzb.png',
            list:[
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:1,
                src:"../../../images/video-img1.png",
                isLive:"0",
                playVideo:true
              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:2,
                src:"../../../images/video-img2.png",
                isLive:"1",
                playVideo:true

              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:3,
                src:"../../../images/video-img3.png",
                isLive:"1",
                playVideo:true

              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:4,
                src:"../../../images/video-img4.png",
                isLive:"0",
                playVideo:true

              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:5,
                src:"../../../images/video-img5.png",
                isLive:"0",
                playVideo:true
              },
            ]
          },
          {
            subTitle:'妇科',
            icon:'../../assets/icon/education/fk.png',
            list:[
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:1,
                src:"../../../images/video-img1.png",
                isLive:"0",
                playVideo:true
              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:2,
                src:"../../../images/video-img2.png",
                isLive:"1",
                playVideo:true

              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:3,
                src:"../../../images/video-img3.png",
                isLive:"1",
                playVideo:true

              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:4,
                src:"../../../images/video-img4.png",
                isLive:"0",
                playVideo:true

              },
              {
                date:"明天",
                time:"9:00",
                host:"江小白",
                zc:"主任医师",
                ks:"肿瘤外科",
                content:"长了乳腺肿瘤怎么办？会变癌吗",
                id:5,
                src:"../../../images/video-img5.png",
                isLive:"0",
                playVideo:true
              },
            ]
          }
        ],
      }
    },
  }
</script>

<style scoped lang="scss">
    @import "../../styles/var";
    .tab-title{

    }
    .icon{
        width: 20px;
        height: 20px;
    }
    .video-content-img{
        width: 210px;
        height: 120px;
        cursor: pointer;
        position: relative;
        span{
            display: inline-block;
            padding: 2px 6px;
            background-color: #FE8705;
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 12px;
            color: #FFFFFF;
            border-radius: 2px;
        }
    }
    @each $d in 1, 2, 3, 4, 5,6,7,8,9,10 {
        div.video-content-img#{$d} {
            background-image: url("../../assets/icon/education/video-img#{$d}.png");
        }
    }
    .icon-ava{
        display: inline-block;
        background-image: url("../../assets/icon/education/video-user-ava.png");
        background-repeat: no-repeat;
        background-size: 14px 14px;
        padding-left: 18px;
    }
    .video-msg-t,.video-msg-b{
        margin-top: 13px;
        span{
            margin-right: 3px;
        }
        span+span{
            margin-left: 8px;
            margin-right: 0;
        }
    }
    .video-msg-b{
        margin-top: 8px;
    }
    .video-msg{
        margin-top: 13px;
    }
    .video-msg-ic{
        display: inline-block;
        width: 70px;
        height: 20px;
        line-height: 20px;
        color: #8A4026;
        border: 1px solid #FEDACD;
        border-radius: 9px;
        text-align: center;
    }

</style>